import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCN from './zh-CN/index'
import enUS from './en-US/index'
import Cookies from 'js-cookie'

Vue.use(VueI18n)
export const messages = {
  'zh-CN': {
    '_lang': '简体中文',
    ...zhCN,
    ...zhCNLocale
  },
  'en-US': {
    '_lang': 'English',
    ...enUS,
    ...enLocale
  }
}
export default new VueI18n({
  locale: Cookies.get('t-language') || "zh-CN",
  messages
})



// WEBPACK FOOTER //
// ./src/i18n/index.js